<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 14 14">
		<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
			<path d="M.5 7A6.5 6.5 0 1 0 7 .5a7.23 7.23 0 0 0-5 2" />
			<path d="m2.5.5l-.5 2L4 3m3 .5v4L4.4 8.8" />
		</g>
	</svg>
</template>
